import React, { useState } from 'react';
import { useSubscriptionsStore } from '../../../store/models/subscriptions';
import ConfirmDialog from '../../components/confirmDialog';

function useSubscriptionDialogs({ unsubscribe, addSchedule, removeSchedule }) {
    const subscriptionsStore = useSubscriptionsStore();

    const [unsubscribeConfirmOpen, setUnsubscribeConfirmOpen] = useState(false);
    const [unsubscribeSuccessOpen, setUnsubscribeSuccessOpen] = useState(false);
    const [removeConfirmOpen, setRemoveConfirmOpen] = useState(false);
    const [addSuccessOpen, setAddSuccessOpen] = useState(false);

    const [pendingSubscription, setPendingSubscription] = useState(null);
    const [pendingRemove, setPendingRemove] = useState({ subscriptionId: null, scheduleId: null, scheduleName: null });

    function openUnsubscribeDialog(subscription) {
        setPendingSubscription(subscription);
        setUnsubscribeConfirmOpen(true);
    }

    function openRemoveDialog(subscriptionId, scheduleId) {
        const schedules = subscriptionsStore.connectedSchedules[subscriptionId] || [];
        const schedule = schedules.find((s) => s.scheduleId === scheduleId || s.id === scheduleId);
        setPendingRemove({ subscriptionId, scheduleId, scheduleName: schedule?.scheduleName || schedule?.name });
        setRemoveConfirmOpen(true);
    }

    function openAddSuccessDialog() {
        setAddSuccessOpen(true);
    }

    function handleUnsubscribeConfirm() {
        setUnsubscribeConfirmOpen(false);
        unsubscribe(pendingSubscription);
        setUnsubscribeSuccessOpen(true);
    }

    function handleRemoveConfirm() {
        setRemoveConfirmOpen(false);
        removeSchedule(pendingRemove.subscriptionId, pendingRemove.scheduleId);
    }

    function renderDialogs() {
        return (
            <React.Fragment>
                <ConfirmDialog
                    open={unsubscribeConfirmOpen}
                    variant="warn"
                    title="Are you sure?"
                    subMessage={`This will remove ${pendingSubscription?.publisher?.name || 'this publisher'} from your calendar.`}
                    confirmLabel="Yes, unsubscribe"
                    cancelLabel="Cancel"
                    onConfirm={handleUnsubscribeConfirm}
                    onClose={() => setUnsubscribeConfirmOpen(false)}
                />
                <ConfirmDialog
                    open={unsubscribeSuccessOpen}
                    variant="success"
                    title="Unsubscribed"
                    subMessage={`You have successfully unsubscribed from ${pendingSubscription?.publisher?.name || 'this publisher'}.`}
                    onClose={() => setUnsubscribeSuccessOpen(false)}
                />
                <ConfirmDialog
                    open={removeConfirmOpen}
                    variant="warn"
                    title="Are you sure?"
                    subMessage={`This will remove ${pendingRemove.scheduleName || 'this schedule'} from your calendar.`}
                    confirmLabel="Yes, remove"
                    cancelLabel="Cancel"
                    onConfirm={handleRemoveConfirm}
                    onClose={() => setRemoveConfirmOpen(false)}
                />
                <ConfirmDialog
                    open={addSuccessOpen}
                    variant="success"
                    title="Schedule Added"
                    subMessage="Events will now appear in your calendar."
                    onClose={() => setAddSuccessOpen(false)}
                />
            </React.Fragment>
        );
    }

    return {
        openUnsubscribeDialog,
        openRemoveDialog,
        openAddSuccessDialog,
        renderDialogs,
    };
}

export default useSubscriptionDialogs;
